import React from "react";

export default function About() {
  return (
    <main>
      <p>
        This application contains snippets from various Codecademy articles. You can browse all our articles and read them in their entirety <a href="https://www.codecademy.com/articles">here</a>.
      </p>
    </main>
  );
}
